"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-3 w-20 bg-muted/40 animate-pulse" />
        <div className="h-3 w-24 bg-muted/40 animate-pulse" />
        <div className="h-3 w-16 bg-muted/40 animate-pulse" />
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-foreground font-default uppercase text-[12px] tracking-[0.15em] relative inline-block group">
            <span className="relative">
              {item.label}
              <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-primary transition-all duration-300 group-hover:w-full" />
            </span>
          </Link>
        </li>)}
    </ul>;
}
const expertiseItems = ["Berita Nasional", "Klarifikasi Resmi", "Zona Pemuda Pancasila", "Liputan Live", "Kerjasama Media"];
const socialItems = [{
  label: "Instagram",
  href: "#"
}, {
  label: "Facebook",
  href: "#"
}, {
  label: "YouTube",
  href: "#"
}];
const bottomLinks = [{
  label: "Kebijakan Privasi",
  href: "/PrivacyPolicyPage"
}, {
  label: "Pedoman Media Siber",
  href: "/CyberMediaGuidePage"
}, {
  label: "Kontak",
  href: "/ContactPage"
}];
export default function Footer() {
  return <section data-section-id="3691" id="mobilebottomnavigation" className="relative bg-background text-foreground pt-[120px] pb-12 overflow-hidden">
      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-primary" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {}
        <div className="mb-16 md:mb-24">
          <h2 className="font-default font-extrabold text-foreground leading-[0.85] tracking-[-0.05em] select-none" style={{
          fontSize: "clamp(4rem, 14vw, 14rem)"
        }}>
            ABADI.NEWS
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col gap-5">
            <div className="font-default uppercase text-[11px] tracking-[0.2em] text-primary">
              Redaksi
            </div>
            <div className="font-default text-base leading-relaxed text-foreground/90">
              Jl. Nasional No. 1
              <br />
              Jakarta Pusat
              <br />
              Indonesia
            </div>
            <div className="font-default text-sm italic text-muted-foreground leading-relaxed">
              Senin — Jumat
              <br />
              09:00 — 17:00 WIB
            </div>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <div className="font-default uppercase text-[11px] tracking-[0.2em] text-primary">
              Navigasi
            </div>
            <MenuProvider menu_id="1173">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <div className="font-default uppercase text-[11px] tracking-[0.2em] text-primary">
              Kanal Utama
            </div>
            <ul className="flex flex-col gap-3">
              {expertiseItems.map((item, i) => <li data-index={i} key={item} className="font-default uppercase text-[12px] tracking-[0.15em] text-foreground/90">
                  {item}
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <div className="font-default uppercase text-[11px] tracking-[0.2em] text-primary">
              Hubungi Kami
            </div>
            <Link to="mailto:redaksi@abadi.news" className="font-default italic text-base text-foreground hover:text-primary transition-colors duration-300">
              redaksi@abadi.news
            </Link>
            <Link to="tel:+62211234567" className="font-default text-sm text-foreground/90 hover:text-primary transition-colors duration-300 tracking-wider">
              +62 21 123 4567
            </Link>
            <ul className="flex flex-col gap-2 mt-2">
              {socialItems.map((social, i) => <li data-index={i} key={social.label}>
                  <Link to={social.href} className="font-default uppercase text-[12px] tracking-[0.15em] text-foreground/90 hover:text-primary transition-colors duration-300 relative inline-block group">
                    <span className="relative">
                      {social.label}
                      <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-primary transition-all duration-300 group-hover:w-full" />
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="relative flex items-center justify-center mb-12">
          <div className="absolute inset-x-0 h-px bg-border" />
          <span className="relative bg-background px-6 font-default text-[11px] tracking-[0.3em] text-muted-foreground">
            — ABADI —
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          {}
          <div className="font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground text-center md:text-left">
            © MMXXIV ABADI.NEWS · SEMUA HAK DILINDUNGI
          </div>

          {}
          <div className="flex items-center justify-center gap-2 font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground">
            <span className="relative flex h-1.5 w-1.5">
              <span className="absolute inline-flex h-full w-full animate-ping bg-primary opacity-75" />
              <span className="relative inline-flex h-1.5 w-1.5 bg-primary" />
            </span>
            <span>JAKARTA · INDONESIA</span>
          </div>

          {}
          <div className="flex items-center justify-center md:justify-end gap-4">
            {bottomLinks.map((link, i) => <Link data-index={i} key={link.label} to={link.href} className="font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground hover:text-primary transition-colors duration-300">
                {link.label}
              </Link>)}
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-primary" />
    </section>;
}